import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  idToken: string;

  constructor(private auth: AuthService, private _clipboardService: ClipboardService) { }

  copy = () => {
    this._clipboardService.copyFromContent(this.idToken);
  }

  ngOnInit() {

    this.auth.idToken.subscribe(idToken => {
      this.idToken = idToken;
    })
  }

}
